export default __webpack_public_path__ + "static/media/mini-trampapo-logo.e2a40e24.png";